<template>
  <div class="print_box" id="print_box" ref="print">
    <!-- <slot></slot> -->
    <div id="watermark_box" class="watermark_box"></div>
    <div class="title">评标专家抽取表</div>
    
    <div class="des_big_box">
      <div class="des_box">
        <div class="des_box_title">项目编号</div>
        <div class="des_box_content">{{ infoObj.tradeTenderProjectCode }}</div>
      </div>
      <div class="des_box">
        <div class="des_box_title">项目名称</div>
        <div class="des_box_content">{{ infoObj.tenderProjectName }}</div>
      </div>
      <div class="des_box_two">
        <div class="des_box_two_t">
          <div class="des_box_title">评标地点</div>
          <div class="des_box_content">{{ infoObj.evalAddress }}</div>
        </div>
        <div class="des_box_two_t">
          <div class="des_box_title">集合地点</div>
          <div class="des_box_content">{{ infoObj.partAddress }}</div>
        </div>
      </div>
      <div class="des_box_two">
        <div class="des_box_two_t">
          <div class="des_box_title">评标时间</div>
          <div class="des_box_content">{{ infoObj.evalStartTime }}</div>
        </div>
        <div class="des_box_two_t">
          <div class="des_box_title">评标耗时</div>
          <div class="des_box_content">{{ infoObj.evalElapsedTime }}小时</div>
        </div>
      </div>
      <div class="des_box_two des_box_two_last">
        <div class="des_box_two_t">
          <div class="des_box_title">抽取人/单位</div>
          <div class="des_box_content">{{ infoObj.extractionUnit }}</div>
        </div>
        <div class="des_box_two_t">
          <div class="des_box_title">抽取时间</div>
          <div class="des_box_content">{{ infoObj.extractionTime }}</div>
        </div>
      </div>
    </div>

    <el-table :data="tableData" border style="width: 100%; margin-top: 16px">
      <el-table-column type="index" align="center" label="序号" class-name="index_width" width="50"></el-table-column>
      <el-table-column prop="name" align="center" label="姓名" class-name="name_width" min-width="100"></el-table-column>
      <el-table-column prop="phone" align="center" label="电话" class-name="phone_width" min-width="100"></el-table-column>
      <el-table-column prop="workUnit" align="center" label="工作单位" min-width="180"></el-table-column>
      <el-table-column prop="idCard" align="center" label="身份证" class-name="idCord_width" min-width="100"></el-table-column>
      <el-table-column prop="date" align="center" label="签名" class-name="name_width" min-width="100"></el-table-column>
    </el-table>

    <div class="footer_box">
      <span class="footer_box_time">打印时间：{{ dateTime }}</span>
      <span>打印单位：{{infoObj.printUnit}}</span>
    </div>
  </div>
</template>

<script>
import dayjs from "@/utils/dayjs.js";

export default {
  name: "VPrint",
  props: {
    id: {
      type: String,
      default: "Vprint",
    },
    portrait: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: () => ({}),
      description: "Vprint数据返回",
    },
  },
  data() {
    return {
      dateTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      infoObj: {},
      tableData: [],
    };
  },
  methods: {
    doWaterMark(width, height, content) {
      let box = document.getElementById("print_box");
      let WaterBox = document.getElementById("watermark_box");
      let boxWidth = box.clientWidth;
      let boxHeight = box.clientHeight;
      for (let i = 0; i < Math.floor(boxHeight / height); i++) {
        for (let j = 0; j < Math.floor(boxWidth / width); j++) {
          let next = document.createElement("div");
          next.setAttribute("class", "watermark");
          next.style.width = width + "px";
          next.style.height = height + "px";
          next.style.display = "inline-block";
          next.style.marginLeft = "16px";
          next.style.transform = "rotate(-30deg)";
          next.style.userSelect = "none";
          next.style.pointerEvents = "none";
          next.innerText = content;
          WaterBox.appendChild(next);
        }
      }
    },

    print() {
      const qu = this.$route.query;
      this.$http.get(`/expertController/expertPrint?entityId=${qu.id}&tenderCode=${qu.tenderCode}`).then((res) => {
        const { code, data } = res.data;
        if (code == 1) {
          this.infoObj = data;
          this.tableData = data.expertVoList || [];
          this.dateTime = dayjs(data.dateTime).format("YYYY-MM-DD HH:mm:ss");
          this.doWaterMark(210, 100, "咸宁市公共资源交易系统");
          this.$nextTick(() => {
            this.$print(this.$refs.print);
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.print_box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -2;
  box-sizing: border-box;
  padding: 24px 24px;
  .watermark_box {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 18px;
    overflow: hidden;
    user-select: none;
    pointer-events: none;
    text-align: center;
    opacity: 0.08;
    z-index: 999;
  }

  .title {
    text-align: center;
    font-size: 24px;
    margin-bottom: 20px;
  }

  .des_big_box {
    width: 100%;
    margin-bottom: 16px;
    background-color: #fff;
    .des_box {
      display: flex;
    }
    .des_box_title {
      width: 110px;
      min-height: 40px;
      line-height: 40px;
      border: 1px solid #ebeef5;
      text-align: center;
      border-bottom: none;
    }
    .des_box_content {
      flex: 1;
      text-align: left;
      min-height: 40px;
      line-height: 40px;
      padding-left: 8px;
      border: 1px solid #ebeef5;
      border-left: none;
      border-bottom: none;
    }
    .des_box_two {
      width: 100%;
      display: flex;
      .des_box_two_t {
        display: flex;
        width: 50%;
      }
    }

    .des_box_two_last {
      .des_box_title {
        border-bottom: 1px solid #ebeef5;
      }
      .des_box_content {
        border-bottom: 1px solid #ebeef5;
      }
    }
  }

  .footer_box {
    margin-top: 16px;
    .footer_box_time {
      padding-right: 16px;
    }
  }

  ::v-deep {
    .el-table {
      .el-table__header-wrapper .el-table__header tr th {
        background-color: transparent !important;
      }
    }
  }
}

@media print {
  @page {
    size: auto; //打印可以选择布局：横向，纵向
    // size: landscape;//横向
    // size: portrait;//纵向
    margin: 0mm; //默认边距
    mso-header: none !important; /* 去除页眉 */
    mso-footer: none !important;
  }
  ::v-deep .el-table {
    border: 2px solid #ebeef5 !important;

    .el-table__header-wrapper .el-table__header tr th {
      border-right: 1px solid #ebeef5 !important;
      border-bottom: 2px solid #ebeef5 !important;
    }
    .index_width {
      width: 50px !important;
    }
    .name_width {
      width: 80px !important;
    }
    .phone_width {
      width: 120px !important;
    }
    .idCord_width {
      width: 180px !important;
    }
  }
}
</style>
